import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  viboWelcome: {
    '--g': 'content-box 50% 50% / 200% 200% no-repeat',
    position: 'fixed',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    backgroundColor: 'var(--background-default)',
    zIndex: 100,
    display: 'grid',
    placeContent: 'center',
    placeItems: 'center',
    gap: '40px',
    WebkitMask: `
      linear-gradient(#000 0 0),
      linear-gradient(calc(135deg + var(--a,0deg)), #000 50%, #0000 0) var(--g),
      linear-gradient(calc(-45deg + var(--a,0deg)), #000 50%, #0000 0) var(--g)
    `,
    WebkitMaskComposite: 'xor, source-over',
    maskComposite: 'exclude, add',
    animation: 'maskIn 0.7s ease-out forwards',
    animationDelay: '0.3s',

    '&.cancel': {
      pointerEvents: 'none',
    },

    '& .logo': {
      width: '495px',
      transform: 'translateY(-40%)',
      opacity: 0,
      animation: 'from-top 0.6s linear forwards',
      animationDelay: '0.9s',
    },

    '& .text': {
      width: '275px',
      transform: 'translateY(50%)',
      opacity: 0,
      animation: 'from-bottom 0.6s forwards',
      animationDelay: '0.7s',
    },

    '& .viboButton': {
      border: 'none',
      marginTop: '15vh',
      fontWeight: 'bold',
      background: 'linear-gradient(90deg, #9a8d05 0%, #d6d308 100%)',
      minWidth: '15rem',
      transform: 'translateY(50%)',
      opacity: 0,
      animation: 'from-bottom 0.6s forwards',
      animationDelay: '1.6s',
    },
  },

  '@global': {
    '@keyframes maskIn': {
      from: {
        WebkitMaskPosition: '100% 0%, 0% 100%',
      },
      to: {
        WebkitMaskPosition: '0% 0%, 100% 100%',
      },
    },

    '@keyframes from-bottom': {
      from: {
        transform: 'translateY(50%)',
        opacity: 0,
      },
      to: {
        transform: 'translateY(0)',
        opacity: 1,
      },
    },

    '@keyframes from-top': {
      from: {
        transform: 'translateY(-40%)',
        opacity: 0,
      },
      to: {
        transform: 'translateY(0)',
        opacity: 1,
      },
    },
  },
}));

export default useStyles;
